import { useEffect, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

/**
 * ScrollToTop is used as a wrapper of App routes
 * It will scroll to page top in each route transition
 */
const ScrollToTop = ({ history, children }) => {
  useEffect(() => {
    const unlisten = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return <Fragment>{children}</Fragment>;
};

export default withRouter(ScrollToTop);
